<template>
  <b-card
    title="Questionnaire"
    class="shadow-sm h-100"
  >
    <div v-if="surveyAnswers.length === 0">
      Le questionnaire n'a pas encore été rempli
    </div>

    <div v-else>
      <div v-for="topic in topics">
        <div class="mt-4 mb-2 topic bold-text">{{topic.title}}</div>

        <b-row>
          <b-col sm="6" v-for="category in categories">
            <div v-if="category.surveyTopicId === topic.id">
              <div class="mb-1 category bold-text">{{category.title}}</div>

              <div v-for="surveyAnswer in surveyAnswers">
                <div v-if="surveyAnswer.surveyCategory !== null
              && surveyAnswer.surveyCategory.id === category.id
              && surveyAnswer.surveyTopic.id === topic.id
            " class="mb-1">
                  <p class="question mb-0">{{surveyAnswer.surveyQuestion.title}} :</p>
                  <p class="answer">
                    {{surveyAnswer.chosenOption != null ? surveyAnswer.chosenOption.title : surveyAnswer.textFieldValue}}
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>


        <div v-for="surveyAnswer in surveyAnswers">
          <div v-if="surveyAnswer.surveyCategory === null
              && surveyAnswer.surveyTopic.id === topic.id">
            <span class="question">{{surveyAnswer.surveyQuestion.title}} :</span>
            <span class="answer">
              {{surveyAnswer.chosenOption != null ? surveyAnswer.chosenOption.title : surveyAnswer.textFieldValue}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import api from '../../services/api';

export default {
  name: "AnimalSurvey",
  props: {
    animalId: String
  },

  data(){
    return {
      topics: [],
      categories: [],
      surveyAnswers: []
    }
  },

  mounted(){
    this.fetchSurvey();
  },

  methods: {

    fetchSurvey(){
      api
        .get(`/survey/getCurrentSurveyForAnimal?animalId=${this.animalId}`)
        .then(response => {
          response.data.forEach((surveyAnswer) => {
            if(this.topics.some(t => t.title === surveyAnswer.surveyTopic.title) === false){
              this.topics.push(surveyAnswer.surveyTopic)
            }
            if(surveyAnswer.surveyCategory !== null
              && this.categories.some(c => c.title === surveyAnswer.surveyCategory.title) === false){
              this.categories.push(surveyAnswer.surveyCategory)
            }
            this.surveyAnswers.push(surveyAnswer)
          })
        })
    },
  }
}
</script>

<style scoped>
.topic{
  font-size: var(--title-level-three-font-size);
  color: var(--main-color);
}

.category{
  color: var(--secondary-color);
}

.question{
  color: var(--neutral-400);
}

.answer{
}
</style>



// WEBPACK FOOTER //
// src/views/animal/AnimalSurvey.vue